import { adminApi } from '~/api'
import { useMutation } from '@tanstack/react-query'

export const useCreateSoftwaresMutation = () => {
  return useMutation((values) => {
    return adminApi.createSoftware(values)
  })
}

export const useEditSoftwaresMutation = (id) => {
  return useMutation((values) => {
    return adminApi.editSoftware(id, values)
  })
}
